/**
 * 首页 IndexPc / IndexPcAge 与内页 IndexLayout 共用：右侧抽屉菜单项与背景图。
 * project_type === 2 为年龄组，否则为成年组；最后一项用于切换两个首页。
 */
const IMG = 'https://bc-api.ccachina.net/public/images';

export const BC_SLIDE_MENU_BG = `${IMG}/bc-index-bg.jpg`;

export const BC_INDEX_LOGO_SENIOR = `${IMG}/bc-index-logo.png`;
export const BC_INDEX_LOGO_AGE = `${IMG}/bc-index-logo-age.png`;

/**
 * @param {number} [explicitType] 1 成年组，2 年龄组
 */
export function getBcIndexLogoUrl(explicitType) {
  const type = explicitType != null ? explicitType : getProjectType();
  return type === 2 ? BC_INDEX_LOGO_AGE : BC_INDEX_LOGO_SENIOR;
}

export const BC_SLIDE_MENU_BASE_ITEMS = [
  { labelKey: '官网菜单竞赛', icon: 'home', path: '/schedules' },
  { labelKey: '官网菜单新闻资讯', icon: 'bell' },
  { labelKey: '官网菜单代表团', icon: 'users', path: '/sai-data-list' },
  { labelKey: '官网菜单票务', icon: 'ticket', path: '/ticketing' },
  { labelKey: '官网菜单观众中心', icon: 'calendar', path: '/spectator' },
  { labelKey: '官网菜单商务', icon: 'info' },
  { labelKey: '官网菜单赞助商', icon: 'building' },
  { labelKey: '官网菜单城市文化', icon: 'image' },
];

/** 成年组首页 → 跳转年龄组 */
const BC_SLIDE_MENU_SWITCH_TO_AGE = {
  labelKey: '官网菜单世青赛全称',
  icon: 'calendar',
  path: '/indexpc-age',
  homeSwitch: true,
};

/** 年龄组首页 → 跳转成年组 */
const BC_SLIDE_MENU_SWITCH_TO_SENIOR = {
  labelKey: '官网菜单世锦赛全称',
  icon: 'calendar',
  path: '/indexpc',
  homeSwitch: true,
};

export function getProjectType() {
  const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('project_type') : null;
  return raw === '2' || raw === 2 ? 2 : 1;
}

/**
 * @param {number} [explicitType] 首页可传入 1/2，与当前页一致，避免 mounted 前 localStorage 未同步
 */
export function getBcSlideMenuItems(explicitType) {
  const type = explicitType != null ? explicitType : getProjectType();
  const switchItem = type === 2 ? BC_SLIDE_MENU_SWITCH_TO_SENIOR : BC_SLIDE_MENU_SWITCH_TO_AGE;
  return BC_SLIDE_MENU_BASE_ITEMS.concat([switchItem]).map(function (item) {
    return Object.assign({}, item);
  });
}

/** @deprecated 请使用 getBcSlideMenuItems() */
export const BC_SLIDE_MENU_ITEMS = getBcSlideMenuItems();

export function setProjectTypeForHomePath(path) {
  if (path === '/indexpc-age') {
    localStorage.setItem('project_type', '2');
  } else if (path === '/indexpc') {
    localStorage.setItem('project_type', '1');
  }
}

export function navigateSlideMenuItem(router, item) {
  if (!item || !item.path) {
    return false;
  }
  if (item.homeSwitch) {
    setProjectTypeForHomePath(item.path);
  }
  router.push({ path: item.path });
  return true;
}



// WEBPACK FOOTER //
// ./src/page/mainindex/bcSlideMenuConfig.js